const CLASS_ACTIVE = 'is-active';
const CLASS_HIDE = 'is-hide';

class Services {
    private servicesObjectWrapper: HTMLElement;
    private servicesDocumentsWrapper: HTMLElement;
    private servicesDocumentsCloseButtons: HTMLElement[];
    private servicesDocumentsBlocks: HTMLElement[];
    private servicesDocumentsActions: HTMLElement[];

    init(wrapper: HTMLElement): void {
        this.servicesObjectWrapper = wrapper;

        this._setElements();
        this._bindEvents();
    }

    private _setElements(): void {
        /* eslint-disable */
        this.servicesDocumentsWrapper = this.servicesObjectWrapper.querySelector('.j-services-object__documents') as HTMLElement;
        this.servicesDocumentsCloseButtons = [...this.servicesDocumentsWrapper.querySelectorAll('.j-services-object__documents-close')] as HTMLElement[];
        this.servicesDocumentsBlocks = [...this.servicesDocumentsWrapper.querySelectorAll('.j-services-object__documents-block')] as HTMLElement[];
        this.servicesDocumentsActions = [...this.servicesObjectWrapper.querySelectorAll('.j-services-object__action')] as HTMLElement[];
        /* eslint-enable */
    }

    private _bindEvents(): void {
        this.servicesDocumentsCloseButtons.forEach((button: HTMLElement) => {
            button.addEventListener('click', () => {
                this.servicesDocumentsWrapper.classList.add(CLASS_HIDE);

                setTimeout(() => {
                    this.servicesDocumentsWrapper.classList.remove(CLASS_ACTIVE);
                    this.servicesDocumentsWrapper.classList.remove(CLASS_HIDE);
                }, 300);
            });
        });

        this.servicesDocumentsActions.forEach((button: HTMLElement) => {
            button.addEventListener('click', () => {
                this.servicesDocumentsBlocks.forEach((block: HTMLElement) => {
                    block.classList.remove(CLASS_ACTIVE);
                });

                const block = this.servicesDocumentsBlocks.find((item: HTMLElement) => {
                    return item.dataset['block'] === button.dataset['block'];
                });

                if (block) {
                    block.classList.add(CLASS_ACTIVE);
                }

                this.servicesDocumentsWrapper.classList.add(CLASS_ACTIVE);
            });
        });
    }
}

export default Services;
